import React from 'react';
import { useGame } from '../context/GameContext';
import { formatXP, getStreakTierInfo } from '../utils/xpSystem';
import './XPBar.css';

const XPBar = () => {
  const {
    totalXP,
    level,
    levelTitle,
    xpForNextLevel,
    currentStreak,
    bestStreak,
    achievements,
    theme,
    toggleTheme
  } = useGame();

  const streakInfo = getStreakTierInfo(currentStreak);

  return (
    <div className="xp-bar-container">
      <div className="xp-bar-content">
        {/* Level Badge */}
        <div className="level-badge">
          <span className="level-number">Lv.{level}</span>
          <span className="level-title">{levelTitle}</span>
        </div>

        {/* XP Progress */}
        <div className="xp-progress-container">
          <div className="xp-progress-bar">
            <div
              className="xp-progress-fill"
              style={{ width: `${xpForNextLevel.percentage}%` }}
            />
          </div>
          <div className="xp-progress-text">
            {xpForNextLevel.isMaxLevel ? (
              <span>MAX LEVEL - {formatXP(totalXP)} XP</span>
            ) : (
              <span>{formatXP(xpForNextLevel.current)} / {formatXP(xpForNextLevel.required)} XP</span>
            )}
          </div>
        </div>

        {/* Stats */}
        <div className="xp-stats">
          {/* Streak */}
          {currentStreak > 0 && (
            <div className={`streak-display ${currentStreak >= 10 ? 'streak-hot' : ''}`}>
              <span className="streak-icon">🔥</span>
              <span className="streak-count">{currentStreak}</span>
              {streakInfo.multiplier > 1 && (
                <span className="streak-multiplier">{streakInfo.multiplier}x</span>
              )}
            </div>
          )}

          {/* Best Streak */}
          {bestStreak > 0 && (
            <div className="best-streak" title={`Best streak: ${bestStreak}`}>
              <span className="best-streak-icon">⚡</span>
              <span className="best-streak-count">{bestStreak}</span>
            </div>
          )}

          {/* Achievements */}
          <div className="achievements-count" title={`${achievements.length} achievements unlocked`}>
            <span className="achievements-icon">🏆</span>
            <span className="achievements-number">{achievements.length}</span>
          </div>

          {/* Theme Toggle */}
          <button
            className="theme-toggle"
            onClick={toggleTheme}
            aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
            title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
          >
            {theme === 'light' ? '🌙' : '☀️'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default XPBar;
